<template>
  <div>
    <card>
      <div class="overall-search-wrapper">
        <div class="row">
          <div class="col-2">
            <base-input
              label="Source"
              v-model="overAllTable.filter.Src"
              placeholder="Source"
            ></base-input>
          </div>
          <div class="col-2">
            <base-input
              label="Destination"
              v-model="overAllTable.filter.Dst"
              placeholder="Destination"
            ></base-input>
          </div>
          <div class="col-2">
            <base-input
              label="From"
              v-model="overAllTable.filter.FromDate"
              type="date"
            >
            </base-input>
          </div>
          <div class="col-2">
            <base-input
              label="To"
              type="date"
              v-model="overAllTable.filter.ToDate"
              placeholder="mike@email.com"
            >
            </base-input>
          </div>
          <div class="col-2">
            <base-button
              class="btn-block"
              slot="footer"
              type="success"
              @click="GetTableData(overAllTable.filter,overAllTable.pagination)"
              fill
              >Search</base-button
            >
          </div>
        </div>
      </div>
    </card>
    <base-table
      :data="overAllTable.data"
      :columns="overAllTable.columns"
      thead-classes="text-primary"
    >
    </base-table>
  </div>
</template>
<script>
import { BaseTable } from "@/components";
import * as HTTPMethods from "@/helpers.js";

export default {
  data() {
    return {
      overAllTable: {
        columns: [
          "nr",
          "callDate",
          "source",
          "destination",
          "billSec",
          "duration",
          "callStateType",
        ],
        data: [],
        filter: {
          FromDate: "2021-01-01",
          ToDate: "2021-09-20",
          Dst: null,
          Src: null,
        },
        pagination: {
          PageNumber: 1,
          PageSize: 150,
        },
        test: {
          source: "100",
          destination: "101",
          duration: 1123,
          billSec: 1120,
          callStateType: "Answer",
          callDate: "2021-09-12T20:45:00",
        },
      },
    };
  },
  components: {
    BaseTable,
  },
  computed: {},
  methods: {
    GetTableData(filter,pagination) {
      HTTPMethods.OverallStatisticsGet(
        filter,
        pagination
      ).then((response) => {
        let a = 0;
        response.forEach((g, i) => {
          g.nr = ++i;
        });
        this.overAllTable.data = response;
      });
    },
  },
  created() {
    this.GetTableData(this.overAllTable.filter,this.overAllTable.pagination);
  },
};
</script>
<style>
</style>
